export default "__VITE_ASSET__2e5cbde1__"